import { styled as styledMui, Box, IconButton } from "@mui/material";

export const PaginatorContainer = styledMui(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  padding: "6px 12px",
  borderRadius: "10px",
  // border: `1px solid ${theme.palette.divider}`,
  backgroundColor: "transparent",
}));

export const NavBtn = styledMui(IconButton)(({ theme }) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  color: theme.palette.text.primary,
  "&.Mui-disabled": {
    color: theme.palette.text.disabled,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));
